import React from 'react';
import cn from '@/utils/cn';
import { IQuestion } from '@/components/staffer/Grading/types';
import { StimuliContent, StimuliData } from '@/components/staffer/Grading/utils';
import AnswerKey from '@/components/staffer/Grading/QuestionCards/AnswerKey';
import styles from '@/components/staffer/Grading/QuestionCards/questionCard.module.scss';
import { useQuestionRubric } from '@/components/staffer/ExerciseBuilder/Rubric/useQuestionRubric';

type RubricData = ReturnType<typeof useQuestionRubric>['data'];

interface BaseQuestionModeCardProps {
  answerKeyHtml?: string;
  children: ReactChildren;
  question: IQuestion;
  rubricData?: RubricData;
  stimuli?: StimuliData;
}

const BaseQuestionModeCard = ({
  answerKeyHtml,
  children,
  question,
  rubricData,
  stimuli,
}: BaseQuestionModeCardProps) => (
  <div className={styles.card}>
    <div className={styles.questionCardHeader}>
      Question
    </div>
    <div className={cn(styles.bodyWrapper, styles.noBorder)}>
      <StimuliContent stimuli={stimuli} />
      {children}
      {question.type !== 'PromptOnly' && (
        <AnswerKey
          answerKeyHtml={answerKeyHtml}
          question={question}
          rubricData={rubricData}
        />
      )}
    </div>
  </div>
);

export default BaseQuestionModeCard;
